// extracted by mini-css-extract-plugin
module.exports = {"delivery":"styles_delivery__M8Ij4","delivery__statistic":"styles_delivery__statistic__AO8_V","rotate":"styles_rotate__qRPiI","rotate-reverse":"styles_rotate-reverse__F2_sQ"};